const PatientWatchTM = () => (
	<h1>
		Patient Watch<sup className="text-[0.8rem]"> TM</sup>
	</h1>
);

export default PatientWatchTM;
